<template>
  <div class="price-slider">
    <div class="ps-ruler">
      <div class="ps-slider-container">
        <v-slider
          v-model="rulerValue"
          :min="minPrice"
          :max="maxPrice"
          color="#5bb1f6"
          thumb-color="#2196f3"
          thumb-label="always"
          step="15"
          @end="onSliderEnd"
        ></v-slider>
      </div>
      <div class="ps-end"></div>
      <div class="ps-tail"></div>
      <div class="ps-body"></div>
      <div class="ps-head"></div>
      <div class="ps-end ps-end-end"></div>

      <div class="ps-label ps-label-agency-price">
        <span class="ps-label-tiny">Agency Price</span>
        <br />$299
      </div>

      <div
        class="ps-label ps-label-members-price"
        :style="{opacity:membersLabelOpacity, top:membersLabelTop + 'px'}"
      >
        <span class="ps-label-tiny">Member Discount</span>
        <br />30% off
      </div>

      <div
        class="ps-label ps-label-snaps-price"
        :style="{opacity:snapsLabelOpacity, top:snapsLabelTop + 'px'}"
      >
        <span class="ps-label-tiny">Use Snaps to Save More</span>
        <br />60% off
      </div>

      <div class="ps-label ps-label-small-price-left">$119</div>
      <div class="ps-label ps-label-small-price-center">$164</div>
      <div class="ps-label ps-label-small-price-right">$209</div>

      <div class="ps-calculations">
        <div class="ps-calculation ps-calculation-discount">
          <div class="ps-calculation-label">Discount</div>
          <div class="ps-calculation-value ps-value-discount">{{ percentageOff}}%</div>
        </div>

        <div class="ps-calculation ps-calculation-price">
          <div class="ps-calculation-label">Your Price</div>
          <div class="ps-calculation-value ps-value-price">${{ finalPrice}}</div>
        </div>

        <div class="ps-calculation ps-calculation-snaps">
          <div class="ps-calculation-label">{{ snapsLabel }}</div>
          <div class="ps-calculation-value">
            <div class="points-container">
              <div v-if="snapsLabel === 'Snaps Bonus'" class="points-up-sign">+</div>
              <div v-if="snapsLabel === 'Snaps Cost'" class="points-down-sign">-</div>

              <div class="points-icon">
                <img src="/images/icons/snap.svg" class="points-icon-img" />
              </div>

              <div class="points">{{ displayedSnapsCost }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ps-confirmation">
        You currently have
        <span class="snaps-count">{{ user.points | bigNumber }}</span> snaps.
        <br />After requesting this service, you'll have
        <span
          class="snaps-count"
        >{{ user.points + snapsCost * -1 | bigNumber }} snaps</span>.
      </div>
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";

export default {
  name: "ServiceOption",
  props: ["service", "user"],
  data: function() {
    return {
      minPrice: null,
      maxPrice: null,
      agencyPrice: null,
      maxSnaps: null,
      rulerValue: null,
      percentageOff: null,
      finalPrice: null,
      snapsCost: null,
      snapsLabelOpacity: 100,
      snapsLabelTop: -7,
      membersLabelOpacity: 100,
      membersLabelTop: -65,
      snapsLabel: "Snaps Bonus",
      displayedSnapsCost: null
    };
  },
  components: { Points },
  watch: {
    rulerValue: function(newValue, oldValue) {
      //const rulerPercentage = Math.round(((newValue - 30) / 30) * 100);
      const rulerPercentage =
        ((newValue - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;

      this.percentageOff = rulerPercentage;
      const percent = this.percentageOff / 100;
      const percentFilled = (percent - 1) * -1;

      //this.snapsLabelOpacity = 1.2 + percent * 0.5 * -1;
      this.snapsLabelTop = -60 + 35 * percent;

      this.membersLabelOpacity = 1;
      this.membersLabelTop = -25 + 35 * percent * -1;

      this.percentageOff = Math.round((newValue / this.agencyPrice) * 100);
      this.percentageOff = (this.percentageOff - 100) * -1;
      this.snapsCost =
        Math.round(this.maxSnaps * percentFilled) - this.maxSnaps / 2;
      if (this.snapsCost === -0) {
        this.snapsCost = 0;
      }
      this.finalPrice = newValue;

      this.snapsLabel = this.snapsCost <= 0 ? "Snaps Bonus" : "Snaps Cost";
      this.displayedSnapsCost =
        this.snapsCost < 0 ? this.snapsCost * -1 : this.snapsCost;
    }
  },
  methods: {
    onSliderEnd: function(value) {
      this.$emit("priceChanged", value, this.snapsCost);
    }
  },
  async created() {
    this.maxPrice = this.service.max_price;
    this.minPrice = this.service.min_price;
    this.agencyPrice = this.service.price;
    this.maxSnaps = this.service.max_snap_cost;
  },
  async mounted() {
    this.rulerValue = this.maxPrice;
  }
};
</script>

<style scoped lang="scss">
$color-grid-lines: #aaa;

.price-slider {
  width: 580px;
  margin: 40px auto;
  margin-left: -4px;
  margin-top: 140px;
  margin-bottom: 470px;
}

.ps-ruler {
  position: relative;
}

.ps-body {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 2px;
  background: $color-grid-lines;
}

.ps-end {
  position: absolute;
  width: 2px;
  height: 32px;
  background: $color-grid-lines;
  top: 25px;
  left: 0;
}
.ps-end-end {
  left: 100%;
  background: $color-grid-lines;
}

.ps-slider-container {
  position: absolute;
  width: 40%;
  top: 10px;
  left: 30%;
  z-index: 1000;
}

.ps-calculations {
  position: absolute;
  top: 150px;
  width: 80%;

  left: 10%;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  background: #fff;
  border-radius: 200px;

  .ps-calculation {
    float: left;
    width: 33%;
    height: 80px;
    border-right: 1px solid #ddd;
  }
  .ps-calculation:last-child {
    border-right: 0;
  }
  .ps-calculation-label {
    padding-top: 10px;
    text-align: center;
    font-size: 11pt;
    text-transform: uppercase;
    color: #111;
    font-family: $font-family;
    font-weight: 700;
    line-height: 1.3em;
  }
  .ps-calculation-value {
    padding-top: 6px;
    text-align: center;
    font-size: 16pt;
    color: #111;
    font-family: $font-family;
    font-weight: 500;
    line-height: 1.3em;
  }
}

$labels-above-top: -40px;
$labels-bottom-top: 120px;

.ps-label {
  position: absolute;
  width: 30%;
  text-align: center;
  font-size: 12.5pt;
  text-transform: uppercase;
  color: #111;
  font-family: $font-family;
  font-weight: 600;
  line-height: 1.3em;
  transform: translateY(0px);
  transition: all 0.3s ease;
}
.ps-label-agency-price {
  top: $labels-above-top;
  left: 85%;
}
.ps-label-members-price {
  top: $labels-above-top - 25px;
  left: 54.5%;
  color: $color-blue;
}
.ps-label-snaps-price {
  top: $labels-above-top + 18px;
  left: 13%;
  width: 35%;
  color: darken(#fbc02d, 15%);
}

.ps-label-small-price-left {
  top: $labels-above-top + 98px;
  left: 12%;
  width: 35%;
  color: #888;
}
.ps-label-small-price-center {
  top: $labels-above-top + 98px;
  left: 32%;
  width: 35%;
  color: #888;
}
.ps-label-small-price-right {
  top: $labels-above-top + 98px;
  left: 52%;
  width: 35%;
  color: #888;
}

.ps-label-tiny {
  font-size: 10pt;
  font-weight: 700;
}

.ps-value-price {
  color: $color-blue !important;
}
.ps-value-discount {
  color: darken(#4caf50, 7%) !important;
}

.v-slider__thumb {
  background: #90caf9 !important;
  border: 0 !important;
}

.ps-confirmation {
  position: absolute;
  top: 250px;
  width: 80%;
  left: 10%;
  font-family: $font-family;
  text-align: center;
}

// Points Tag
.points-container {
  display: flex;
  justify-content: center;
  border-radius: 28px;
  padding: 3px 0 0 0;
  margin-left: -2px;
  zoom: 1;
}
.border {
  border: 2px solid darken($color-sidebar, 4%) !important;
}
.points-icon {
  flex-grow: 0;
  padding-top: 0px;
  margin-top: -1px;
}
.points-icon-img {
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  flex-grow: 0;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}

.snaps-count {
  color: darken(#ffa000, 6%);
  font-weight: 600;
}

.points-up-sign {
  margin-right: 4px;
  line-height: 24px;
  font-size: 19pt;
  font-weight: 700;
  color: #66bb6a;
}
.points-down-sign {
  margin-right: 4px;
  line-height: 22px;
  font-size: 19pt;
  font-weight: 700;
  color: #aaa;
}
</style>